export const SN_SHIPMENT = 'shipment'
export const SHIPMENT_LIST_UPDATED = SN_SHIPMENT + '/SEARCH_UPDATED'
export const SHIPMENT_CURRENT_UPDATED = SN_SHIPMENT + '/CURRENT_UPDATED'
export const SHIPMENT_CURRENT_PRODUCT_ADDED = SN_SHIPMENT + '/CURRENT_PRODUCT_ADDED'